import { defineStore } from 'pinia';
import type {Ref} from 'vue';
import {ref} from 'vue';

export const useLoginStore = defineStore('LoginStore', () => {
  const items: Ref<LoginItems[]> = ref([]);
  function addLoginComponent(item: LoginItems) {
    items.value.push(item);
  }

  function removeLoginComponent() {
    items.value = [];
  }

  return { addLoginComponent, removeLoginComponent, items};
});

interface LoginItems {
  name: string,
}
